<script>
export default {
  name: 'googleMapMarker',
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    marker: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    const poi = new this.google.maps.Marker({
      // position: this.marker.position,
      // eslint-disable-next-line radix,max-len
      position: { lat: this.marker.geo, lng: this.marker.deliveryPointCordLng },
      marker: this.marker,
      map: this.map,
      label: this.marker.label,
    });
    const infoWindow = new this.google.maps.InfoWindow({
      content: `<h1>${this.marker.deliveryPointName}</h1>`,
    });
    // eslint-disable-next-line func-names
    poi.addListener('click', function () {
      infoWindow.close();
      infoWindow.open(this.map, poi);
    });
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
  render() {
    return null;
  },
};
</script>

<style scoped>

</style>
